import { render } from "./EducationalFormFilter.vue?vue&type=template&id=20e6d059&ts=true"
import script from "./EducationalFormFilter.ts?vue&type=script&lang=ts&external"
export * from "./EducationalFormFilter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__